export default __webpack_public_path__ + "static/card-example3-399ebcee0d302ee92f0a146718ce8c41.png";